module.exports = __webpack_public_path__ + "img/resourceGreen.83ca5f2d.png";